export default function SubscriptionPlansSettings() {
    return (
        <div>
            subscription plans settings
        </div>
    );
};